import React from 'react';
import { Users } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import './Sidebar.css';

const Sidebar = () => {
  const location = useLocation();
  const isActive = (path) => location.pathname === path;

  return (
    <div className="sidebar">
      <div style={{ height:'100%',border: '1px solid #e9d5d5',borderRadius: '24px',boxShadow:'0 8px 32px 0 rgba(16, 185, 129, 0.10), 0 1.5px 6px rgba(0, 0, 0, 0.06);', margin: '20px 0px', padding: '24px 32px',display:'flex',flexDirection:'column',gap:'48px',boxShadow:'0 8px 32px 0 rgba(16, 185, 129, 0.15), 2px 0 5px rgba(0, 0, 0, 0.08)'}}>
        <div className="sidebar-header">
          <div className="logo">
            <img src="/assets/logo.svg" alt="PrediMind Logo" className="logo-image" />
          </div>
          <h1 className="sidebar-title">PrediMind</h1>
        </div>
        <div className="nav-buttons">
          <Link to="/" className={`nav-button${isActive('/')||isActive('booking-form')||isActive('doctor-booking') ? ' nav-button-active' : ''}`}>Book a call</Link>
          <Link to="/home" className={`nav-button${isActive('/home') ? ' nav-button-active' : ''}`}>Home</Link>
          <Link to="/blogs" className={`nav-button${isActive('/blogs') ? ' nav-button-active' : ''}`}>Blogs</Link>
        </div>
        <div className="testimonial">
          <div className="joined-section">
            {/* <Users size={20} color="#10b981" className="users-icon" /> */}
            <p className="joined-text">
              Over 1,583+ people have<br />already joined.
            </p>
          </div>
          <p className="testimonial-text">
            "The testimonials<br />Carousals............"
          </p>
          <div style={{display:'flex',flexDirection:'column',gap:'16px',alignItems: 'center'}}>
{/*           
          <Link to="/booking-form" className="book-call-button">
        Book a call
        <span className="arrow">→</span>
      </Link> */}
      <Link to="/contact"className={`policy-button${isActive('/contact') ? ' policy-button-active' : ''}`}>Contact Us</Link>
      <button className="policy-button">T&C Policy</button>
      <button className="policy-button">Privacy Policy</button>
      </div>
        </div>
        
      </div>
      
    </div>
  );
};

export default Sidebar; 